var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"four-zero-four"},[_c('div',{staticClass:"four-zero-four-container"},[_c('div',{staticClass:"error-code"},[_vm._v("403")]),_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.$t('lisa_web_you_can_not_access_this_page')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }